import React, { useEffect, useState } from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { FacilityDrillPage } from './facility-drill-page'
import { useDispatch } from 'react-redux'
import { loadAllDeals } from 'app/state/ducks/deals/thunks'
import { loadEntities } from 'app/state/ducks/entities/thunks'
import { loadAllFacilities, loadOneFacility } from 'app/state/ducks/facilities/thunks'
import { loadAllFacilityAmendments } from 'app/state/ducks/facility-amendments/thunks'
import { loadIndexRateOptions } from 'app/state/ducks/index-rate-options/thunks'
import { loadAllEntityProfiles } from 'app/state/ducks/entity-profile/thunks'
import { loadAllLoanConversions } from 'app/state/ducks/loan-conversions/thunks'
import { loadAllLoanIncreases } from 'app/state/ducks/loan-increases/thunks'
import { loadAllLoanRollovers } from 'app/state/ducks/loan-rollovers/thunks'
import { loadWireInstructions } from 'app/state/ducks/wire-instructions/thunks'
import { useParams } from 'react-router-dom'
import { loadSchedulerAmortizationByFacility } from 'app/state/ducks/amortization/thunks'
import { loadContacts } from 'app/state/ducks/contacts/thunks'
import { loadFeesByFacility } from 'app/state/ducks/fees/thunks'
import { loadCalendars } from 'app/state/ducks/holiday-calendars/thunks'
import { loadAllLoans, loadLockedLoans } from 'app/state/ducks/loans/thunks'
import { ContractType } from 'app/models/common-types'
import { loadLendersPositionsByFacility } from 'app/state/ducks/lenders-positions/thunks'
import { loadAllLetterOfCredits } from 'app/state/ducks/letters-of-credits/thunks'
import { loadNotesByContract } from 'app/state/ducks/notes/thunks'
import { loadAllPrincipalPayments } from 'app/state/ducks/principal-payment/thunks'
import { loadPaymentInKinds } from 'app/state/ducks/payment-in-kind/thunks'
import { loadAllLoanAmendments } from 'app/state/ducks/loan-amendments/thunks'
import { loadAllLoanMerges } from 'app/state/ducks/loan-merges/thunks'


export function FacilityLandingPage() {
    const dispatch = useDispatch()
    const { facilityId, status } = useParams()
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        if (!facilityId) return;

        setLoading(true);
        Promise.all([
            dispatch(loadEntities()),
            dispatch(loadAllFacilities()),
            status?.toLowerCase() === 'terminated'
                ? dispatch(loadOneFacility(facilityId, 'Terminated'))
                : Promise.resolve(),
            dispatch(loadWireInstructions()),
            dispatch(loadAllDeals()),
            dispatch(loadAllFacilityAmendments()),
            dispatch(loadIndexRateOptions()),
            dispatch(loadAllEntityProfiles()),
            dispatch(loadAllLoanRollovers()),
            dispatch(loadAllLoanIncreases()),
            dispatch(loadAllLoanConversions()),
            dispatch(loadAllLoanMerges()),
            dispatch(loadContacts()),
            dispatch(loadCalendars()),
            dispatch(loadAllPrincipalPayments()),
            dispatch(loadPaymentInKinds()),
            dispatch(loadFeesByFacility(facilityId ?? '')),
            dispatch(loadSchedulerAmortizationByFacility(facilityId ?? '')),
            dispatch(loadAllLoans(facilityId)),
            dispatch(loadLockedLoans(facilityId)),
            dispatch(loadAllLetterOfCredits(facilityId)),
            dispatch(loadLendersPositionsByFacility(facilityId ?? '')),
            dispatch(loadNotesByContract(facilityId ?? '', ContractType.Facilities)),
            dispatch(loadAllLoanAmendments(facilityId ?? ''))
        ])
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    }, [facilityId, dispatch]);

    return (
        <PageLayout>
            <FacilityDrillPage loading={loading} />
        </PageLayout>
    )
}